// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"DiscountOneProduct_pageHolder__2XCm8","centerHolder":"DiscountOneProduct_centerHolder__30dgd"};